import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { alert, Alert, back, back_icon } from "../../assets/img";

const Topbar = ({ header, subHead, back }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const type = location?.state?.type;

  // console.log("type", type);

  const [saideBarShow, setSaidBarShow] = useState(true);
  const [name, setName] = useState();

  // useEffect(() => {
  //     let userName = JSON.parse(localStorage.getItem("loggedUser"))
  //     setName(userName?.username);
  // }, [])

  return (
    <div className="d-flex ac-jb topbar">
      <div className="">
        <div className="d-flex ac-js gap-3">
          {back && (
            <img
              src={back_icon}
              onClick={() => {
                navigate(-1);
              }}
              className="back-arrow"
              alt=""
            />
          )}

          {type == "view" || type == "edit" || type == "add" ? (
            <img
              src={back_icon}
              onClick={() => {
                navigate(-1);
              }}
              className="back-arrow"
              alt=""
            />
          ) : (
            ""
          )}
          <div>
            <h2 className=" f-w600 f3 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 white ">
              {/* {localStorage.getItem("role")} */}
              {header}
            </h2>
            <p className=" f1 fs-sm-15 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-18 sec mt-0 white">
              {subHead}
            </p>
          </div>
        </div>
      </div>

      <div className="d-flex ac-jc gap-3">
        <div className="text-end">
          <h4 className="f2 fs-sm-15 fs-md-17 fs-lg-18 fs-xl-19 fs-xxl-20 my-1 white">
            {localStorage.getItem("name") ?? "Admin"}
          </h4>
          <p className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 white">
            {localStorage.getItem("role") ?? "Super Administrator"}
          </p>
        </div>
        <img src={alert} className="alert_icon pointer" alt="" />
      </div>
    </div>
  );
};

export default Topbar;
